import React from 'react';

import card1Image from './images/card1.png';
import card2Image from './images/card2.png';
import card3Image from './images/card3.png';
import arrowIcon from './images/arrow_icon.png';
import arrowLightIcon from './images/arrow_light_icon.png';
import css from './SectionBlog.module.css';
import { FormattedMessage } from 'react-intl';

const SectionBlog = props => {
  return (
    <div className={css.root}>
      <p className={css.subtitle}>
        <FormattedMessage id="LandingProfessionalsPage.SectionBlog.subtitle" />
      </p>
      <p className={css.title}>
        <FormattedMessage id="LandingProfessionalsPage.SectionBlog.title" />
      </p>

      <div className={css.horizontalWrapper}>
        <div className={css.cardWrapper}>
          <div className={css.cardTopWrapper}>
            <img className={css.cardImage} src={card1Image} />
            <p className={css.cardTitle}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card1.title" />
            </p>
            <p className={css.cardInfo}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card1.info" />
            </p>
          </div>
          <div className={css.cardBottomWrapper}>
            <p className={css.cardDate}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card1.date" />
            </p>

            <div className={css.readMoreWrapper}>
              <p className={css.readMore}>
                <FormattedMessage id="LandingProfessionalsPage.SectionBlog.readMore" />
              </p>
              <img className={css.arrow} src={arrowIcon} />
            </div>
          </div>
        </div>

        <div className={css.cardWrapper}>
          <div className={css.cardTopWrapper}>
            <img className={css.cardImage} src={card2Image} />
            <p className={css.cardTitle}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card2.title" />
            </p>
            <p className={css.cardInfo}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card2.info" />
            </p>
          </div>
          <div className={css.cardBottomWrapper}>
            <p className={css.cardDate}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card2.date" />
            </p>

            <div className={css.readMoreWrapper}>
              <p className={css.readMore}>
                <FormattedMessage id="LandingProfessionalsPage.SectionBlog.readMore" />
              </p>
              <img className={css.arrow} src={arrowIcon} />
            </div>
          </div>
        </div>

        <div className={css.cardWrapper}>
          <div className={css.cardTopWrapper}>
            <img className={css.cardImage} src={card3Image} />
            <p className={css.cardTitle}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card3.title" />
            </p>
            <p className={css.cardInfo}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card3.info" />
            </p>
          </div>

          <div className={css.cardBottomWrapper}>
            <p className={css.cardDate}>
              <FormattedMessage id="LandingProfessionalsPage.SectionBlog.card3.date" />
            </p>

            <div className={css.readMoreWrapper}>
              <p className={css.readMore}>
                <FormattedMessage id="LandingProfessionalsPage.SectionBlog.readMore" />
              </p>
              <img className={css.arrow} src={arrowIcon} />
            </div>
          </div>
        </div>
      </div>

      <div className={css.goToBlogWrapper}>
        <p className={css.goToBlog}>
          <FormattedMessage id="LandingProfessionalsPage.SectionBlog.goToBlog" />
        </p>
        <img className={css.arrow} src={arrowLightIcon} />
      </div>
    </div>
  );
};

export default SectionBlog;
